import CloudSearchDomain from "aws-sdk/clients/cloudsearchdomain";
import { Auth } from "@aws-amplify/auth";
import AWS from "aws-sdk";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import {SNACKBAR_DURATION} from "../EquipmentList/Constants/constants";
const cloudsearch = new CloudSearchDomain({
  region: process.env.REACT_APP_AWS_PROJECT_REGION,
  endpoint: process.env.REACT_APP_AWS_CLOUD_SEARCH_ENDPOINT,
});

function sanitizeSearchQuery(searchValue, fieldsToWrap = []) {
  let result = searchValue;
  fieldsToWrap.forEach((field) => {
    const regex = new RegExp(
      `${field}:([^"\\s][^"]*\\s[^"\\s]*)(?=\\s+(AND|OR)\\s+|$)`,
      "g"
    );
    result = result.replace(regex, (match, value) => {
      if (value.startsWith('"') && value.endsWith('"')) {
        return `${field}:${value}`;
      }
      return `${field}:"${value}"`;
    });
  });
  return result;
}

/**
 * Normalizes CloudSearch boolean filters for `should_assisted` and `is_hazardous`
 * from "Yes"/"No" or "true"/"false" to `1`/`0` in the given query string.
 * @param {string} query - CloudSearch query or filter string to normalize.
 * @returns {string} Normalized query string with boolean values converted to 1/0.
 */
const normalizeBooleanFilters = (query) => {
  if (!query || typeof query !== 'string') return query;
  return query
    .replace(/(should_assisted|is_hazardous):\*?"(Yes|No)"\*?/gi, (_, match, value) => `${match}:${value.toLowerCase() === 'yes' ? 1 : 0}`)
    .replace(/(should_assisted|is_hazardous):\*?"(true|false)"\*?/gi, (_, match, value) => `${match}:${value.toLowerCase() === 'true' ? 1 : 0}`);
};

export const CloudSearchConfig = async ({ start, size, searchValue, sort, sortBy, queryOptions, filterQuery }) => {
  // FYI: in Booking FE we don't include int columns in CloudSearch – we only use them for filtering and sorting
  if (queryOptions) {
    const fieldsExcludedFromQueryOptions = [
      'booking_access_control',
      'is_hazardous',
      'checklists',
      'should_assisted',
    ];
    fieldsExcludedFromQueryOptions.forEach((field) => {
      queryOptions = queryOptions.replace(`'${field}',`, '');
    });
  }

  searchValue = normalizeBooleanFilters(searchValue);
  filterQuery = normalizeBooleanFilters(filterQuery);

  const MAX_OR_CLAUSES = 990;
  const countOrClauses = (str = "") => (str.match(/\sOR\s/g) || []).length;
  const totalOrClauses =
    countOrClauses(searchValue || "") + countOrClauses(filterQuery || "");

  if (totalOrClauses > MAX_OR_CLAUSES) {
    snackbarService.show({
      message: "Too many conditions, please select less options",
      type: "error",
      duration: SNACKBAR_DURATION,
    });
  }

  AWS.util.update(AWS.CloudSearchDomain.prototype, {
    convertGetToPost: async (request) => {
      const authorizationid = (await Auth.currentSession()).getIdToken().getJwtToken();
      var httpRequest = request.httpRequest;
      var path = httpRequest.path.split("?");
      httpRequest.method = "POST";
      httpRequest.path = path[0];
      httpRequest.body = path[1];
      httpRequest.headers["Content-Length"] = httpRequest.body.length;
      httpRequest.headers["Content-Type"] = "application/x-www-form-urlencoded";
      httpRequest.headers["Access-Control-Allow-Origin"] = "*";
      httpRequest.headers["authorizationid"] = authorizationid;
    },
  });

  try {
    return new Promise((resolve, reject) => {
      const safeQuery = sanitizeSearchQuery(searchValue, ["site_name"]);
      let params = {
        query: safeQuery ? `-_id:4epf_* AND ${safeQuery}` : "* -_id:4epf_* AND -cluster_id:*",
        queryParser: "lucene",
        start,
        size,
        sort: `${sortBy} ${sort}`,
      };

      if (filterQuery) {
        params["filterQuery"] = filterQuery;
      }

      if (queryOptions) {
        params["queryOptions"] = queryOptions;
      }

      cloudsearch.search(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
          let hits = data?.hits?.hit;
          let count = data?.hits?.found;
          if (!Array.isArray(hits)) {
            console.log('invalid cs response');
            hits = [];
          }
          const fields = hits.map((item) => {
            return { ...item.fields, id: [item?.id] };
          });

          resolve({
            data: fields,
            count: count || 0,
          });
        }
      });
    });
  } catch (error) {
    console.log("API error..", error);
  }
};
